// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nGA6","col":"styles_col__3jn5f"};